<template>
  <div class="subscribe">
    <h2>{{ $t('newsletter.title') }}</h2>
    <p>{{ $t('newsletter.text') }}</p>
    <div class="subscribe__form">
      <input type="text" v-model="user.firstname" id="voornaam" :placeholder="$t('contact.form.firstname')">
      <input type="text" v-model="user.lastname" id="naam" :placeholder="$t('contact.form.lastname')">
      <input type="email" @input="error=''" v-model="user.email" id="email" :placeholder="$t('contact.form.email')">
      <div class="checkbox">
        <input type="checkbox" id="gdpr-news" v-model="user.gdpr"><label class="checkbox__label" for="gdpr-news">{{ $t('contact.form.gdpr') }}
        <router-link target="_blank" to="/privacy">{{ $t('privacy.title') }}</router-link>
      </label>
      </div>
    </div>
    <button class="button" :class="{'button--disabled':submitDisabled}" @click="subscribe">{{ $t('newsletter.action') }}</button>
    <p v-if="error" class="error">{{ $t(`contact.form.error.${error}`) }}</p>
    <p v-if="isSent" class="success">{{ $t('newsletter.success') }}</p>
  </div>
</template>

<script>
import UserService from "@/services/user";

export default {
  name: "TheNewsletter",
  data() {
    return {
      error: "",
      isSent: "",
      user: {
        firstname: "",
        lastname: "",
        email: "",
        gdpr: 0
      }
    }
  },

  created() {

  },

  computed: {
    submitDisabled() {
      return !(this.user.firstname && this.user.lastname && this.user.email && this.user.gdpr);
    }
  },

  methods: {
    subscribe() {
      this.isSent = false;
      this.error = "";
      if (!this.validateEmail(this.user.email)) {
        this.error = "emailinvalid";
        return;
      }
      UserService.sendForm({
        name: this.user.lastname,
        firstname: this.user.firstname,
        email: this.user.email,
        text: "",
        subject: "Nieuwsbrief registratie",
        subscribe: 1
      })
          .then((res) => {
            if (res && res.status) {
              this.isSent = true;
              this.resetUser();
            }
          });
    },

    resetUser() {
      this.user = {
        firstname: "",
        lastname: "",
        email: "",
        gdpr: 0
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  }
}
</script>